/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:auto}mat-card[_ngcontent-%COMP%] > div.dx-fieldset[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap}mat-card[_ngcontent-%COMP%] > div.dx-fieldset[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin:5px}"];
export { styles as styles };
